const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    width: '60px',
    height: '60px',
    marginBottom: theme.spacing(1),
  },
})

export default styles
